export const portfolioCompanies = [
  {
    name: 'Nebula Compute',
    sector: 'AI Infrastructure',
    stage: 'Seed',
    year: 2024,
    description: 'Distributed inference network turning idle GPUs into a global compute fabric for foundation models.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20visualization%20of%20a%20glowing%20neural%20network%20with%20delicate%20cyan%20particle%20trails%20floating%20over%20a%20dark%20minimalist%20background%2C%20soft%20bokeh%20light%20and%20subtle%20depth%2C%20high-tech%20cinematic%20mood%2C%20clean%20composition%20with%20negative%20space%20suitable%20for%20a%20product%20card&width=800&height=600&seq=vex-portfolio-01&orientation=landscape',
  },
  {
    name: 'Helix Bio',
    sector: 'Synthetic Biology',
    stage: 'Pre-seed',
    year: 2024,
    description: 'Programmable cell therapies designed in silico, manufactured in hours instead of months.',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20microscopic%20visualization%20of%20glowing%20double%20helix%20DNA%20strands%20with%20translucent%20organic%20shapes%20suspended%20in%20a%20dark%20liquid%20background%2C%20clean%20minimalist%20composition%2C%20soft%20teal%20and%20warm%20amber%20highlights%2C%20premium%20editorial%20science%20aesthetic&width=800&height=600&seq=vex-portfolio-02&orientation=landscape',
  },
  {
    name: 'Orbital Forge',
    sector: 'Space & Defense',
    stage: 'Series A',
    year: 2023,
    description: 'In-space manufacturing platform building satellites and structures directly in low earth orbit.',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20futuristic%20satellite%20component%20floating%20against%20a%20dark%20void%20with%20faint%20earth%20curvature%20in%20the%20distance%2C%20clean%20industrial%20design%2C%20soft%20rim%20lighting%20with%20warm%20amber%20glow%2C%20cinematic%20minimal%20composition%20with%20negative%20space%20for%20a%20product%20portfolio%20card&width=800&height=600&seq=vex-portfolio-03&orientation=landscape',
  },
  {
    name: 'Lumen Robotics',
    sector: 'Robotics',
    stage: 'Seed',
    year: 2024,
    description: 'General-purpose humanoid workforce trained in simulation for warehouse and logistics environments.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20humanoid%20robot%20torso%20with%20matte%20white%20panels%20and%20subtle%20internal%20glow%20standing%20in%20a%20clean%20industrial%20studio%20with%20soft%20directional%20lighting%2C%20dark%20moody%20background%20with%20negative%20space%2C%20cinematic%20technology%20aesthetic%20suitable%20for%20portfolio%20display&width=800&height=600&seq=vex-portfolio-04&orientation=landscape',
  },
  {
    name: 'Quantum Ledger',
    sector: 'Fintech / Quantum',
    stage: 'Series A',
    year: 2023,
    description: 'Quantum-resistant settlement layer powering tomorrow’s cross-border financial infrastructure.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20visualization%20of%20interconnected%20glowing%20nodes%20and%20lines%20forming%20a%20cube%20lattice%20over%20a%20dark%20background%2C%20soft%20cyan%20accents%20on%20a%20deep%20charcoal%20stage%2C%20cinematic%20minimalist%20composition%20suitable%20for%20a%20fintech%20product%20card&width=800&height=600&seq=vex-portfolio-05&orientation=landscape',
  },
  {
    name: 'Forge Climate',
    sector: 'Climate Tech',
    stage: 'Seed',
    year: 2024,
    description: 'Direct air capture modules powered by waste industrial heat — sequestering CO₂ at sub-$100/ton.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20industrial%20carbon%20capture%20module%20with%20clean%20metallic%20fins%20on%20a%20dark%20concrete%20floor%2C%20soft%20warm%20amber%20accent%20lights%2C%20cinematic%20product%20photography%20style%20with%20negative%20space%20and%20foggy%20atmospheric%20background%2C%20premium%20climate%20technology%20aesthetic&width=800&height=600&seq=vex-portfolio-06&orientation=landscape',
  },
];

export const sectors = [
  { name: 'Artificial Intelligence', count: 14, icon: 'ri-brain-line' },
  { name: 'Robotics & Automation', count: 9, icon: 'ri-robot-line' },
  { name: 'Climate & Energy', count: 7, icon: 'ri-leaf-line' },
  { name: 'Bio & Life Sciences', count: 6, icon: 'ri-microscope-line' },
  { name: 'Space & Aerospace', count: 4, icon: 'ri-rocket-2-line' },
  { name: 'Quantum & Compute', count: 5, icon: 'ri-cpu-line' },
];

export const ventures = [
  {
    name: 'Atlas Labs',
    year: 2023,
    status: 'Operating',
    description: 'In-house R&D studio prototyping AI agents and autonomous systems for enterprise workflows.',
    metric: '6 products shipped',
  },
  {
    name: 'Northwind Studio',
    year: 2022,
    status: 'Spun out',
    description: 'Brand and product studio that incubated three category-defining consumer fintech apps.',
    metric: '$48M follow-on raised',
  },
  {
    name: 'Signal Labs',
    year: 2024,
    status: 'Incubating',
    description: 'Internal research lab focused on real-time intelligence for defense and critical infrastructure.',
    metric: 'Stealth phase',
  },
];

export const insights = [
  {
    title: 'The next decade of intelligence',
    category: 'Essay',
    date: 'May 2026',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20with%20a%20single%20glowing%20orb%20suspended%20in%20a%20dark%20studio%20surrounded%20by%20delicate%20particle%20trails%2C%20editorial%20technology%20magazine%20aesthetic%2C%20warm%20amber%20rim%20light%20on%20charcoal%20background%2C%20cinematic%20depth%20and%20negative%20space&width=800&height=600&seq=vex-insight-01&orientation=landscape',
  },
  {
    title: 'Why we invested in synthetic biology',
    category: 'Thesis',
    date: 'Apr 2026',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20organic%20translucent%20cell-like%20shapes%20floating%20in%20a%20dark%20fluid%20environment%20with%20soft%20teal%20internal%20glow%2C%20cinematic%20science%20editorial%20photography%2C%20minimal%20composition%20with%20negative%20space%2C%20premium%20biotech%20aesthetic%20suitable%20for%20article%20header&width=800&height=600&seq=vex-insight-02&orientation=landscape',
  },
  {
    title: 'Hard tech needs patient capital',
    category: 'Field note',
    date: 'Mar 2026',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20industrial%20metallic%20gear%20component%20resting%20on%20a%20matte%20black%20surface%20with%20soft%20directional%20studio%20light%20creating%20warm%20amber%20highlights%2C%20cinematic%20editorial%20still%20life%2C%20deep%20negative%20space%2C%20premium%20hardware%20engineering%20aesthetic&width=800&height=600&seq=vex-insight-03&orientation=landscape',
  },
];

export const timeline = [
  { year: '2019', title: 'Founded', detail: 'Vex begins as a small angel syndicate writing first checks into ambitious founders.' },
  { year: '2021', title: 'First Fund', detail: 'Closed inaugural $25M vehicle dedicated entirely to frontier technology.' },
  { year: '2023', title: 'Studio Launch', detail: 'Launched Atlas Labs — our in-house venture studio building alongside founders.' },
  { year: '2025', title: 'Global Footprint', detail: 'Operating across SF, NYC, London, and Singapore with 80+ portfolio companies.' },
  { year: '2026', title: 'Vex III', detail: 'Announced $150M third fund focused on AI-native, robotics, and biotech.' },
];

export const team = [
  {
    name: 'Mira Okafor',
    role: 'General Partner',
    bio: 'Former founder · ex-DeepMind · 15 years backing technical founders.',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20confident%20female%20executive%20with%20short%20dark%20curly%20hair%20wearing%20a%20minimalist%20black%20turtleneck%20against%20a%20soft%20charcoal%20studio%20backdrop%2C%20warm%20rembrandt%20lighting%2C%20premium%20business%20magazine%20portrait%20style%20with%20negative%20space&width=600&height=800&seq=vex-team-01&orientation=portrait',
  },
  {
    name: 'Daniel Reyes',
    role: 'General Partner',
    bio: 'Two-time founder. Operator background in robotics and supply chain.',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20mid-thirties%20male%20technologist%20with%20short%20dark%20hair%20and%20stubble%20wearing%20a%20charcoal%20crewneck%20against%20a%20soft%20dark%20studio%20backdrop%2C%20warm%20directional%20lighting%2C%20premium%20editorial%20business%20portrait%20with%20negative%20space&width=600&height=800&seq=vex-team-02&orientation=portrait',
  },
  {
    name: 'Yuna Park',
    role: 'Principal · Bio & Climate',
    bio: 'PhD in bioengineering. Previously led platform at a leading biotech VC.',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20female%20scientist%20with%20long%20straight%20black%20hair%20wearing%20a%20minimalist%20cream%20blouse%20against%20a%20soft%20dark%20studio%20backdrop%2C%20warm%20directional%20lighting%2C%20premium%20editorial%20portrait%20style%20with%20negative%20space%20on%20one%20side&width=600&height=800&seq=vex-team-03&orientation=portrait',
  },
  {
    name: 'Ari Cohen',
    role: 'Principal · AI & Compute',
    bio: 'Ex-research scientist. Writes the firm’s thesis on intelligence infrastructure.',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20male%20researcher%20with%20glasses%20and%20short%20curly%20hair%20wearing%20a%20dark%20gray%20sweater%20against%20a%20soft%20charcoal%20studio%20backdrop%2C%20warm%20directional%20rembrandt%20lighting%2C%20premium%20editorial%20business%20portrait%20with%20negative%20space&width=600&height=800&seq=vex-team-04&orientation=portrait',
  },
];

export const principles = [
  {
    title: 'Conviction over consensus',
    description: 'We back ideas before they are obvious — and stay when they are unfashionable.',
    icon: 'ri-compass-3-line',
  },
  {
    title: 'Operators, not spectators',
    description: 'Every partner has built and shipped. We sit on the same side of the table as founders.',
    icon: 'ri-tools-line',
  },
  {
    title: 'Long-term by default',
    description: 'Frontier technology takes time. Our capital is patient, our timelines are decades.',
    icon: 'ri-hourglass-line',
  },
  {
    title: 'Build with founders',
    description: 'Through our studio, we co-build product, brand, hiring, and go-to-market in the earliest days.',
    icon: 'ri-stack-line',
  },
];

export const stats = [
  { label: 'Portfolio companies', value: '82' },
  { label: 'Capital deployed', value: '$340M' },
  { label: 'Operating partners', value: '24' },
  { label: 'Global offices', value: '4' },
];

export const partnerLogos = [
  'Forge', 'Nebula', 'Helix', 'Orbital', 'Lumen', 'Quantum', 'Signal', 'Atlas',
  'Northwind', 'Aperture', 'Vector', 'Halo',
];